// Página do cliente (chamados): the access link of the e-mail brings the token in the fragment
// (…/atendimento#acesso=TOKEN), which browsers never send to the server. The page keeps it in this browser for the
// institution's address (localStorage is per address) until the customer leaves or it stops working.
const KEY = 'aubaine.customerAccess'
const TOKEN = /^[A-Za-z0-9_-]{43}$/

export function tokenFromHash(hash: string): string | null {
  const match = /(?:^#|&)acesso=([^&]+)/.exec(hash)
  const token = match ? decodeURIComponent(match[1]!) : null
  return token && TOKEN.test(token) ? token : null
}

// Takes the token of the address (saving it) and removes it from the address bar and the history.
export function takeTokenFromLocation(location: Location = window.location): string | null {
  const token = tokenFromHash(location.hash)
  if (!token) return null
  saveToken(token)
  window.history.replaceState(window.history.state, '', `${location.pathname}${location.search}`)
  return token
}

export function readToken(): string | null {
  try {
    const value = localStorage.getItem(KEY)
    return value && TOKEN.test(value) ? value : null
  } catch {
    return null
  }
}

export function saveToken(token: string) {
  try {
    localStorage.setItem(KEY, token)
  } catch {
    // Storage blocked (private window): the token lives only in memory for this visit.
  }
}

export function clearToken() {
  try {
    localStorage.removeItem(KEY)
  } catch {
    // Same as above.
  }
}
